<template>
  <div class="device-admin">
    <div class="device-header webkit-drag">
      <p class="fl">
        PDF会员-电脑管理
      </p>
      <div
        class="close-btn fr webkit-no-drag"
        @click="closeWin"
      />
    </div>
    <div class="device-list-title">
      <div class="account">
        电脑名称
      </div>
      <div class="os">
        系统
      </div>
      <div class="last-time">
        最后登录日期
      </div>
    </div>
    <ul class="device-list">
      <li
        v-for="(item, index) in device_list"
        :key="index"
        class="device-item device-data"
      >
        <div class="tap">
          <span v-if="item.server_id === server_id">本机</span>
        </div>
        <div class="account">
          {{ item.account || `computer(${index + 1})` }}
        </div>
        <div class="os">
          {{ item.os }}
        </div>
        <div class="last-time">
          {{ formatDate2(new Date(item.last_login_time)) }}
        </div>
        <div class="action action-w">
          <div
            v-if="device_list.length >= 3 && item.server_id !== server_id"
            class="action-btn"
            @click="preDeleteDevice(item)"
          >
            移除
          </div>
        </div>
      </li>
    </ul>
    <div class="tip">
      注：会员账号最多允许在<span class="orange">{{ device_config.server_id_limit }}</span>台电脑上登录，达到上限后无法在其它电脑上登录
    </div>
    <Confirm
      title="PDF会员-提示"
      :show="show == 'confirm'"
      @close="handleConfirmCancle"
      @submit="deleteDevice"
    >
      <div slot="content">
        <span v-if="device_config.unbind_op_freq_limit_text">{{ device_config.unbind_op_freq_limit_text }}内只允许移除<span class="orange">{{ device_config.unbind_op_num }}</span>台电脑，</span>确定移除电脑{{ selected.account }}吗？
      </div>
    </Confirm>
    <Confirm
      title="PDF会员-提示"
      :show="show == 'limit'"
      hide-cancle
      @close="handleLimitCancle"
      @submit="handleLimitSubmit"
    >
      <div slot="content">
        <p><span v-if="device_config.unbind_op_freq_limit_text">{{ device_config.unbind_op_freq_limit_text }}内只允许移除<span class="orange">{{ device_config.unbind_op_num }}</span>台电脑，</span>请{{ formatDate2(new Date((deleteResult.last_op_time + deleteResult.op_freq_limit) * 1000)) }}后再进行操作.<span class="tip-tip">（上次移除日期{{ formatDate2(new Date(deleteResult.last_op_time * 1000)) }}）</span></p>
      </div>
    </Confirm>
  </div>
</template>

<script>
import * as deviceApi from '@/api/device'
import { formatDate2 } from '@/utils/shared'
import client from '@/client/'
import Cookie from 'js-cookie'
export default {
  data () {
    return {
      formatDate2,
      device_list: [],
      device_config: {
        unbind_op_num: 0,
        server_id_limit: 0,
        unbind_op_freq_limit: 0
      },
      selected: {
        selected_server_id: '',
        account: ''
      },
      common: {
        token: '',
        open_id: '',
      },
      deleteResult: {
        last_op_time: new Date(),
        op_freq_limit: 0
      },
      show: '',
      sfrom: '',
      server_id: Cookie.get('svrid')
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      const { openid, token, sfrom } = this.$route.query
      this.common.token = token
      this.common.open_id = openid
      this.sfrom = sfrom
      this.reportShow()
      this.getDeviceList()
      this.getDeviceAdminConfig()
    },
    async getDeviceList () {
      const res = await deviceApi.getDeviceList({ common: this.common })
      this.device_list = res.device_list
    },
    async preDeleteDevice (item) {
      const res = await deviceApi.deleteDevice({ common: this.common, op_server_id: item.server_id, op_status: 'prepare' })
      const ret = res.resp_common.ret
      if (ret === 0) {
        this.selected = item
        this.showConfirm()
      } else if (ret === 5903008) {
        this.deleteResult = res
        this.showLimit()
      } else {
        this.$toast(res.resp_common.msg)
      }
    },
    async deleteDevice () {
      this.reportClick({ click: 1, box_type: 1 })
      const res = await deviceApi.deleteDevice({ common: this.common, op_server_id: this.selected.server_id, op_status: 'action' })
      if (res.resp_common.ret === 0) {
        this.$toast('移除成功')
        this.getDeviceList()
      } else {
        this.$toast(res.resp_common.msg)
      }
      this.closeTipModal()
    },
    async getDeviceAdminConfig () {
      const res = await deviceApi.getDeviceConfig({ common: this.common })
      this.device_config = res
    },
    closeTipModal () {
      this.show = ''
    },
    showLimit () {
      this.show = 'limit'
    },
    showConfirm () {
      this.show = 'confirm'
    },
    closeWin () {
      window.close()
    },
    handleConfirmCancle (type) {
      const map = {
        cancle: 2,
        close: 3
      }
      this.reportClick({ click: map[type], box_type: 1 })
      this.closeTipModal()
    },
    handleLimitSubmit () {
      this.reportClick({ click: 1, box_type: 2 })
      this.closeTipModal()
    },
    handleLimitCancle () {
      this.reportClick({ click: 3, box_type: 2 })
      this.closeTipModal()
    },
    reportShow () {
      client.device.REPORT.reportDeviceAdminShow({ source: this.sfrom })
    },
    reportClick ({ click, box_type }) {
      client.device.REPORT.reportDeviceAdminOperate({ click, box_type })
    }
  }
}
</script>

<style lang="scss" scoped>
.device-admin {
  width: 600px;
  height: 420px;
  background: #F9F9F9;
  font-size: 12px;
  color: #575757;
  * {
    box-sizing: border-box;
  }
}
.device-header {
  height: 30px;
  line-height: 30px;
  background: url(~@/assets/images/deviceAdmin/header-bg.png) no-repeat center center;
  padding-left: 27px;
  padding-right: 10px;
  font-size: 12px;
  color: #B07400;
}
.device-list-title {
  background: #fff;
  border: 1px solid #EFEFEF;
  display: flex;
  padding: 0 136px 0 87px;
  height: 40px;
  line-height: 40px;
  .account {
    // padding-left: 15px;
    width: 177px;
  }
  .os {
    padding-left: 4px;
    width: 125px;
  }
}
.device-list {
  padding: 0 25px;
  height: 318px;
  border-bottom: 1px solid #EFEFEF;
}
.device-item {
  display: flex;
  height: 55px;
  line-height: 55px;
  border-bottom: 1px solid #EFEFEF;
  .tap {
    width: 62px;
    display: flex;
    align-items: center;
   & > span {
      width:36px;
      height:19px;
      background:rgba(246,242,225,1);
      border:1px solid rgba(253, 214, 59, 1);
      border-radius:2px;
      text-align: center;
      color: #732D0A;
      font-size:12px;
      display: inline-block;
      line-height: 17px;
    }
  }
  .account {
    width: 107px;
    overflow: hidden;
    word-wrap: nowrap;
    margin-right: 70px;
  }
  .os {
    flex: 1;
  }
  .last-time {
    width: 75px;
    margin-right: 39px;
    text-align: center;
  }
  .action-w {
    width: 72px;

    padding-top: 15px;
  }
  &:last-child {
    border: none;
  }
}
.tip {
  line-height: 30px;
  padding-left: 16px;
  color: #797979;
}
.action-btn {
  height: 24px;
  line-height: 22px;
  background: #fff;
  width: 74px;
  text-align: center;
  color: #838383;
  border: 1px solid #D3DADC;
  border-radius: 12px;
  cursor: pointer;
  &:hover {
    background: #F2F4F8;
  }
  &:active {
    background: #E4E6E8;
  }
}
.orange {
  color: #FC9300 !important;
}
.tip-tip {
  color: #ababab;
  font-size: 12px;
}
.close-btn {
  width: 12px;
  height: 12px;
  background: url(~@/assets/images/deviceAdmin/close-btn.png) no-repeat left center;
  cursor: pointer;
  margin-top: 9px;
  &:hover {
    background-position-x: center;
  }
  &:active {
    background-position-x: right;
  }
}
</style>
